import { togglePlayerButton } from "./customPlayer";

export function loadYouTubeScript() {
    //console.log("Caricamento API YouTube...");
    window.onYouTubeIframeAPIReady = function () {
        //console.log("✅ YouTube API caricata con successo");
        initYouTubePlayers();
    };
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    tag.onload = function () {
        //console.log("Script YouTube API caricato, in attesa dell'inizializzazione...");
    };
    tag.onerror = function (error) {
        console.error("❌ Errore nel caricamento dell'API YouTube:", error);
    };
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

}

function initYouTubePlayers() {

    document.querySelectorAll('div.video-youtube').forEach((video, i) => {
        let videoContainer = video.closest(".video-container");
        let youtubeID = video.attributes["data-video-id"].value;
        // console.log("youtubeID: ", youtubeID);

        let playButton = videoContainer.querySelector(".custom-play-btn");

        // Crea il messaggio di stato per screen reader 
        let statusMessage = document.createElement("span");
        statusMessage.setAttribute("aria-live", "polite");
        statusMessage.classList.add("sr-only");
        videoContainer.appendChild(statusMessage);

        // Aggiunta attributi ARIA al pulsante (come in Vimeo)
        playButton.setAttribute("role", "button");
        playButton.setAttribute("aria-label", "Riproduci video");
        playButton.setAttribute("tabindex", "0");

        let player = new YT.Player(video, {
            videoId: youtubeID,
            playerVars: {
                rel: 0,            // Prevents showing related videos
                showinfo: 0,       // Hides video information
                loop: 1,
                playlist: youtubeID, // Needed for proper looping without showing related videos
                autoplay: 0,
                controls: 1,
                fs: 0
            },
            events: {
                'onReady': function (event) {
                    // console.log(`✅ Player YouTube pronto: ${youtubeID}`);
                    
                    const playerInstance = event.target;
                    playButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        // console.log('Click su bottone per il video');
                        togglePlayPause(playerInstance, playButton);
                    });
                    // Accessibilità tastiera
                    playButton.addEventListener("keydown", (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            togglePlayPause(playerInstance, playButton);
                        }
                    });
                },
                'onError': function (newstate) {
                    console.error('Player error:', newstate.data);
                }
            }
        });

        function togglePlayPause(player, btn) {
            try {
                if (player.getPlayerState() !== YT.PlayerState.PLAYING) {
                    player.playVideo();                    
                    document.getElementById(`videoCover${youtubeID}`).style.display = "none";
                    btn.classList.add("hidden");
                    togglePlayerButton(btn, false);
                    btn.setAttribute("aria-label", "Pausa video");
                    statusMessage.textContent = "Il video è in riproduzione.";
                }
            } catch (err) {
                console.error("Errore nel controllo play/pause:", err);
            }
        }

    });
}